import React from "react";
import Modal from "../ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import "./style.scss";
import { useWindowSize } from "@app/Helpers";
import DOMPurify from "dompurify";

export default NiceModal.create(() => {
  const modal = useModal();
  const { width } = useWindowSize();
  const XGA = width >= 1020;

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        modal.hide();
      }}
      onAfterClose={() => {
        modal.remove();
      }}
      innerClass={"memory-match-modal"}
    >
      <p
        className="section-header"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(modal.args.question)}}
      ></p>
      <div className="buttons-wrapper">
        <Button
          btnClass={` yellow ${XGA ? "reversed" : ""}`}
          action={
            modal.args.correctAnswer == 0
              ? () => {
                  modal.args.onSuccess();
                  modal.hide();
                }
              : () => {
                  console.log(modal.args.correctAnswer);
                  modal.hide();
                }
          }
        >
          Falsch
        </Button>
        <Button
          btnClass=" yellow "
          action={
            modal.args.correctAnswer == 1
              ? () => {
                  modal.args.onSuccess();
                  modal.hide();
                }
              : () => {
                  modal.hide();
                }
          }
        >
          Wahr
        </Button>
      </div>
    </Modal>
  );
});
